<template>
    <div class="testControl">
        <div class="box">
            <div class="item-form">
                <span class="title-lable">{{ $t('testControl.XZJG') }}</span>
                <span>
                    <el-select 
                        v-model="subminPaperData.orgId" 
                        size="small" filterable 
                        @change="()=>{
                            clearData('subminPaperData', 'planId');
                            clearData('subminPaperData', 'teamOrPlayer');
                            getPlanList('getSubminPaperData', subminPaperData.orgId); 
                        }"
                        :placeholder="$t('testControl.QXZJG')">
                        <el-option
                                v-for="item in orgList" 
                            :key="item.orgId"
                            :label="item.orgName"
                            :value="item.orgId">
                        </el-option>
                    </el-select>
                </span>
            </div>
            <div class="item-form">
                <span class="title-lable">{{ $t('testControl.LXJH') }}</span>
                <span>
                    <el-select 
                        v-model="subminPaperData.planId" 
                        size="small" 
                        filterable 
                        :disabled="!subminPaperData.orgId"
                        @change="()=>{
                            clearData('subminPaperData', 'teamOrPlayer');
                            getTeamOrPlayer('getSubminPaperData', subminPaperData.planId)
                        }"
                        :placeholder="$t('testControl.QXZLXJH')">
                        <el-option
                            v-for="item in getSubminPaperData.planList"
                            :key="item.id"
                            :label="item.planName"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </span>
            </div>
            <div class="item-form">
                <span class="title-lable">{{ $t('testControl.TDR') }}</span>
                <span>
                    <el-select 
                        v-model="subminPaperData.teamOrPlayer" 
                        size="small" 
                        filterable 
                        :disabled="!subminPaperData.planId"
                        :placeholder="$t('testControl.QXZTDR')">
                        <el-option
                            v-for="item in getSubminPaperData.teamOrPlayerList"
                            :key="item.teamIdOrPlayerId"
                            :label="item.teamNameOrPlayerName"
                            :value="item.teamIdOrPlayerId">
                        </el-option>
                    </el-select>
                </span>
            </div>
            <div class="item-form">
                <el-button 
                size="small" 
                :disabled="!subminPaperData.teamOrPlayer"
                @click="()=>{handelClickButton('CHSubmitPaper', subminPaperData.teamOrPlayer)}"
                type="primary">{{ $t('testControl.CHSJ') }}</el-button>
            </div>
        </div>
        <div class="box">
            <div class="item-form">
                <span class="title-lable">{{ $t('testControl.XZJG') }}</span>
                <span>
                    <el-select 
                        v-model="resetPaperData.orgId" 
                        size="small" filterable 
                        @change="()=>{
                            clearData('resetPaperData', 'planId');
                            clearData('resetPaperData', 'paperName');
                            getPlanList('getResetPaperData', resetPaperData.orgId); 
                        }"
                        :placeholder="$t('testControl.QXZJG')">
                        <el-option
                            v-for="(item, index) in orgList"
                            :key="index"
                            :label="item.orgName"
                            :value="item.orgId">
                        </el-option>
                    </el-select>
                </span>
            </div>
            <div class="item-form">
                <span class="title-lable">{{ $t('testControl.LXJH') }}</span>
                <span>
                    <el-select 
                        v-model="resetPaperData.planId" 
                        size="small" filterable 
                        :disabled="!resetPaperData.orgId"
                        @change="()=>{
                            clearData('resetPaperData', 'paperName');
                            getPaperData('resetPaperData', resetPaperData.planId)
                        }"
                        :placeholder="$t('testControl.QXZLXJH')">
                        <el-option
                            v-for="item in getResetPaperData.planList"
                            :key="item.id"
                            :label="item.planName"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </span>
            </div>
            <div class="item-form">
                <span class="title-lable">{{ $t('testControl.XZSJ') }}</span>
                <span>
                    <el-input 
                        :disabled="true"
                        v-model="resetPaperData.paperName" 
                        size="small" filterable :placeholder="$t('testControl.DQWSJ')">
                    </el-input>
                </span>
            </div>
            <div class="item-form">
                <el-button 
                    size="small" 
                    @click="()=>{handelClickButton('paperReset')}"
                    type="primary" 
                    :disabled="!resetPaperData.paperName">{{ $t('testControl.CXBD') }}</el-button>
            </div>
        </div>
        <div class="box">
            <div class="item-form">
                <span class="title-lable">{{ $t('testControl.XZZY') }}</span>
                <span>
                    <el-select 
                        v-model="resetScoreData.majorId" 
                        size="small" filterable 
                        @change="()=>{
                            clearData('resetScoreData', 'planId');
                            clearData('resetScoreData', 'paperId');
                            clearData('resetScoreData', 'orgId');
                            clearData('resetScoreData', 'times');
                            getPaperList('getScoreData', resetScoreData.majorId); 
                        }"
                        :placeholder="$t('testControl.XZZY')">
                        <el-option
                            v-for="(item, index) in majorList"
                            :key="index"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </span>
            </div>
            <div class="item-form">
                <span class="title-lable">{{ $t('testControl.XZSJ') }}</span>
                <span>
                    <el-select 
                        v-model="resetScoreData.paperId" 
                        size="small" filterable 
                        :disabled="!resetScoreData.majorId"
                        @change="()=>{
                            clearData('resetScoreData', 'orgId');
                            clearData('resetScoreData', 'times');
                            clearData('resetScoreData', 'planId');
                            getOrgList('getScoreData', resetScoreData.paperId)
                        }"
                        :placeholder="$t('testControl.XZSJ')">
                        <el-option
                            v-for="item in getScoreData.paperList"
                            :key="item.paperId"
                            :label="item.paperName"
                            :value="item.paperId">
                        </el-option>
                    </el-select>
                </span>
            </div>
            <div class="item-form">
                <span class="title-lable">{{ $t('testControl.XZJG') }}</span>
                <span>
                    <el-select 
                        v-model="resetScoreData.orgId" 
                        size="small" filterable 
                        :disabled="!resetScoreData.paperId"
                        @change="()=>{
                            setTimes()
                            clearData('resetScoreData', 'planId');
                        }"
                        :placeholder="$t('testControl.XZJG')">
                        <el-option
                            v-for="item in getScoreData.orgList"
                            :key="item.orgId"
                            :label="item.orgName"
                            :value="item.orgId">
                        </el-option>
                    </el-select>
                </span>
            </div>
            <div class="item-form">
                <span class="title-lable">{{ $t('testControl.XZSJT') }}</span>
                <span>
                    <el-date-picker
                        v-model="resetScoreData.times"
                        :picker-options="pickerOptions"
                        type="datetimerange"
                        @change="()=>{
                            handleDateChange();
                            clearData('resetScoreData', 'planId');
                            
                        }"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        :disabled="!resetScoreData.orgId"
                        size="small"
                        :range-separator="$t('testControl.Z')"
                        :start-placeholder="$t('testControl.KSSJ')"
                        :end-placeholder="$t('testControl.JSSJ')">
                    </el-date-picker>
                </span>
            </div>
            
            <div class="item-form">
                <span class="title-lable">{{ $t('testControl.XZJH') }}</span>
                <span>
                    <el-select 
                        v-model="resetScoreData.planId" 
                        size="small" filterable 
                        :disabled="resetScoreData.times ? !resetScoreData.times.length : !resetScoreData.times"
                        :placeholder="$t('testControl.XZJH')">
                        <el-option
                            v-for="item in getScoreData.planList"
                            :key="item.id"
                            :label="item.planName"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </span>
            </div>
            <div class="item-form">
                <el-button 
                    size="small" 
                    @click="()=>{handelClickButton('scoreReset')}"
                    type="primary" 
                    :disabled="!resetScoreData.times || getScoreData.planList ? !getScoreData.planList.length : !getScoreData.planList">{{ $t('testControl.CXPF') }}</el-button>
            </div>
        </div>
    </div>
</template>
<script>
import mins from './mins'
export default {
    name: 'testControl',
    mixins: [mins],
}
</script>
<style scoped lang="scss">
.testControl{
    height: 100%;
    width: 100%;
    box-sizing: border-box;
    padding: 24px;
    overflow: auto;
    .box:nth-child(2){
        margin: 40px auto;
    }
    .box{
        border: solid 1px #ccc;
        border-radius: 6px;
        padding: 20px 60px;
        margin: 0 auto;
        width: 517px;
        .item-form{
            text-align: center;
            margin: 20px 0;
            .title-lable{
                @include fontstyle(14px, #000, 400);
                margin-right: 8px;
                display: inline-block;
                width: 59px;
            }
            /deep/ .el-select, /deep/ .el-input, /deep/ .el-date-editor{
                width: 450px;
            }
            /deep/ .el-button{
                width: 280px;
            }
        }
    }
}
</style>